import script from "./NavComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavComponent.vue?vue&type=script&setup=true&lang=ts"

import "./NavComponent.vue?vue&type=style&index=0&id=7cc9c2f1&scoped=true&lang=scss"

import exportComponent from "/Users/joris/Documents/website/film-point-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc9c2f1"]])

export default __exports__